var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.962402H513V342.955H0V0.962402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114.96H513V228.957H0V114.96Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.958H513V342.955H0V228.958Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.062 112.482V127.348C234.062 161.495 189.453 171.957 189.453 171.957C189.453 171.957 144.844 161.496 144.844 127.348V112.482L144.699 68.2074L233.916 67.9409L234.062 112.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.062 112.482V127.348C234.062 161.495 189.453 171.957 189.453 171.957C189.453 171.957 144.844 161.496 144.844 127.348V112.482L144.699 68.2074L233.916 67.9409L234.062 112.482Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.063 112.482V127.348C234.063 161.495 189.454 171.957 189.454 171.957C189.454 171.957 144.845 161.496 144.845 127.348V112.482L159.722 127.348L189.454 105.043L219.197 127.348L234.063 112.482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.958496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/SI.3d776edd7f1e98492dd6ec88279c797f.svg";
export { ForwardRef as ReactComponent };